import * as React from 'react';
import { actions } from 'react-redux-form';
import * as moment from 'moment';
import { Form } from '../';

interface Props {
  isFetching: boolean;
  startDate: Date;
  endDate: Date;
  handleChange: Function;
}

const StatisticsControls = ({
  isFetching,
  startDate,
  endDate,
  handleChange,
}: Props) => (
  <div className="columns">
    <div className="column">
      <Form
        type="statisticControlStart"
        hasButton={false}
        disabled={isFetching}
        handleChange={(data) => handleChange(data)}
        fields={[
          {
            label: 'Start Date',
            name: 'startDate',
            type: 'date',
          },
        ]}
        getDispatch={(dispatch) => {
          dispatch(
            actions.change(
              'statisticControlStart.startDate',
              moment(startDate).format('YYYY-MM-DD'),
            ),
          );
        }}
      />
    </div>
    <div className="column">
      <Form
        type="statisticControlEnd"
        hasButton={false}
        disabled={isFetching}
        handleChange={(data) => handleChange(data)}
        fields={[
          {
            label: 'End Date',
            name: 'endDate',
            type: 'date',
          },
        ]}
        getDispatch={(dispatch) => {
          dispatch(
            actions.change(
              'statisticControlEnd.endDate',
              moment(endDate).format('YYYY-MM-DD'),
            ),
          );
        }}
      />
    </div>
  </div>
);

export default StatisticsControls;
